import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../../accelerator-area.service';
import { AccSpecialist } from '../acc-specialists-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, areaService: AcceleratorAreaService): GridSetup<AccSpecialist> {

	return {
		rowName: { singular: 'Specialist', plural: 'Specialists' },
		getRowKey: row => '' + row.personId,
		stateKey: 'accelerator-specialists-grid',
		actions: getActions(dialogService, areaService),
		buttons: [],
		columns: getColumns(util),
	}
}
